import BaseBridge from 'src/config/bridge/BaseBridge'

import { InterUIBabi } from '@interco/inter-ui-react-lib'

export const Babi = () => <InterUIBabi onClick={BaseBridge.requestBabi} />
